import React from "react";

const FallbackImage = ({
  src,
  alt = "image",
  fallback = "/dummy-img.jpg", 
  className = "",
  ...rest
}) => {
  
  return (
    <img
      src={src}
      alt={alt}
      onError={(e) => {
        e.target.onerror = null; 
        e.target.src = fallback;
      }}
      className={className}
      {...rest} 
    />
  );
};

export default FallbackImage;
